import NpsByDeviceTagWidget from './NpsByDeviceTagWidget';
export default NpsByDeviceTagWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/NpsByDeviceTagWidget/index.js